import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
// Importación necesaria para SurveyResponse
import { Comment } from '../shared/models/commet';
import { environment } from '../../environments/environment';
import { API_ENDPOINT } from '../shared/Constant/constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

    public baseUrl = environment.apiUrl;
    private apiUrl = `${this.baseUrl}${API_ENDPOINT.COMMENTS}`;
    

  constructor(private http: HttpClient) {
  }

  /**
   * Envía un nuevo comentario al backend.
   * Corresponde al endpoint POST /api/v1/comments.
   * @param comment El objeto CustomerComment a enviar.
   * @returns Un Observable con la respuesta del servidor.
   */
  createComment(comment: Comment): Observable<Comment> {
    return this.http.post<Comment>(this.apiUrl, comment);
  }

  /**
   * Obtiene todos los comentarios aprobados para un producto específico.
   * Corresponde al endpoint GET /api/v1/comments/product/{productId}.
   * @param productId El ID del producto para el cual se obtendrán los comentarios.
   * @returns Un Observable con un array de comentarios aprobados.
   */
  getApprovedCommentsByProductId(productId: string): Observable<Comment[]> {
    return this.http.get<Comment[]>(`${this.apiUrl}/product/${productId}`);
  }

}